// Ref: http://plnkr.co/edit/35UQ1TtercCEHIXe4x1I?p=preview
angular.module('sticky', []).directive('sticky', ['$window', function($window) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var child = element.children(0);
            var childOffset = elementOffset(child);
            var offsetTop = attrs.offsetTop ? attrs.offsetTop : childOffset.top;

            function elementOffset(element) {
                var de = document.documentElement;
                var box = element[0].getBoundingClientRect();
                var top = box.top + window.pageYOffset - de.clientTop;
                var left = box.left + window.pageXOffset - de.clientLeft;
                return { top: top, left: left };
            }

            function resizeChild(e, c) {
                // Don't set width to zero
                if (e[0].offsetWidth === 0) {
                    return;
                }
                c.css({ width: e[0].offsetWidth + 'px' });
            }

            angular.element(document).ready(function() {
                resizeChild(element, child);
            });

            angular.element($window).on('resize', function() {
                resizeChild(element, child);
            });

            angular.element($window).on('scroll', function() {
                if (this.pageYOffset >= offsetTop) {
                    child.addClass('sticky');
                } else {
                    child.removeClass('sticky');
                }
            });

            angular.element('.sticky-target').on('scroll', function() {
               var stickyTarget= angular.element('.sticky-target');
               var elemOffset = elementOffset(stickyTarget);
                              
               var sticky = angular.element('.sticky');
               //sticky.top = elemOffset.top;
               sticky.left = elemOffset.left;
               
                //sticky.style.transform = "translateY("+this.scrollTop+"px)";
                console.log(this.scrollTop);
                sticky.attr('style', ['translateY(', this.scrollTop, 'px)'].join(''));
                // if (this.pageYOffset >= offsetTop) {
                //     child.addClass('sticky');
                // } else {
                //     child.removeClass('sticky');
                // }
            });
        }
    };
}]);